import UAParser from 'ua-parser-js';
import { stateType } from './AppStateProvider';
import { getNetworkPathType } from '../../utils/getNetworkPathType';

/**
 * Builds the aggregated final test-results object from the current app state.
 *
 * This is the single source of truth for the report shape and is reused by
 * both the downloadable JSON report and the `complete` postMessage payload so
 * that embedders receive exactly the same data that a user could download.
 */
export function buildFinalTestResults(state: stateType, userAgentInfo: UAParser.IResult) {
  const signalingGateway = state.preflightTest.signalingGatewayReachable ? 'Reachable' : 'Unreachable';
  const turnServers = state.preflightTest.turnServersReachable ? 'Reachable' : 'Unreachable';
  const maxBitrate = state.bitrateTest.report?.values ? Math.max(...state.bitrateTest.report.values) : 0;
  const networkPathType = getNetworkPathType(state.preflightTest.report);

  return {
    audioTestResults: { inputTest: state.audioInputTestReport, outputTest: state.audioOutputTestReport },
    bitrateTestResults: { maxBitrate, ...state.bitrateTest.report },
    browserInformation: userAgentInfo,
    connectivityResults: {
      twilioServices: { ...state.twilioStatus },
      signalingRegion: signalingGateway,
      TURN: turnServers,
      networkPath: networkPathType,
    },
    preflightTestReport: { report: state.preflightTest.report, error: state.preflightTest.error?.message || null },
    videoTestResults: state.videoInputTestReport,
  };
}
